// Actions
export const SET_SEGMENT_ID = 'SET_SEGMENT_ID'

// Action Creators
export function setSegmentId(segmentId) {
  return { type: SET_SEGMENT_ID, segmentId }
}

// Reducer
const initialState = {
  segmentId: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SEGMENT_ID:
      return {
        ...state,
        segmentId: action.segmentId,
      }
    default:
      return state
  }
}
